export interface IValueSpecifiable<T> {
  value: T;
}

export function instanceOfIValueSpecifiable<T>(instance: any): instance is IValueSpecifiable<T> {
  return instance
    && (instance.value !== undefined);
}
